import TicketIcon from '@material-design-icons/svg/filled/confirmation_number.svg?react';
import DeleteIcon from '@material-design-icons/svg/filled/delete.svg?react';
import EmailIcon from '@material-design-icons/svg/filled/email.svg?react';
import GroupIcon from '@material-design-icons/svg/filled/group.svg?react';
import HistoryIcon from '@material-design-icons/svg/filled/history.svg?react';
import HomeIcon from '@material-design-icons/svg/filled/home.svg?react';
import QueryStatsIcon from '@material-design-icons/svg/filled/query_stats.svg?react';
import LeaderboardIcon from '@material-design-icons/svg/filled/leaderboard.svg?react';
import VerifiedUserIcon from '@material-design-icons/svg/filled/verified_user.svg?react';
import { Link, useLocation } from 'react-router';

export function SuperAdminNav() {
  const location = useLocation();

  return (
    <div className="border-b border-neutral-700 bg-neutral-900/50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <nav className="flex gap-x-1 py-4 overflow-x-auto whitespace-nowrap scrollbar-hide">
          <Link
            to="/super"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === '/super'
                ? 'bg-neutral-800 text-white'
                : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
            }`}
          >
            <HomeIcon className="fill-current size-4" />
            Overview
          </Link>
          <Link
            to="/super/users"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === '/super/users'
                ? 'bg-neutral-800 text-white'
                : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
            }`}
          >
            <GroupIcon className="fill-current size-4" />
            Users
          </Link>
          <Link
            to="/super/deleted-dapps"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === '/super/deleted-dapps'
                ? 'bg-neutral-800 text-white'
                : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
            }`}
          >
            <DeleteIcon className="fill-current size-4" />
            Deleted
          </Link>
          <Link
            to="/super/kyb"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === '/super/kyb'
                ? 'bg-neutral-800 text-white'
                : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
            }`}
          >
            <VerifiedUserIcon className="fill-current size-4" />
            KYC/KYB
          </Link>
          <Link
            to="/super/emails"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === '/super/emails'
                ? 'bg-neutral-800 text-white'
                : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
            }`}
          >
            <EmailIcon className="fill-current size-4" />
            Emails
          </Link>
          <Link
            to="/super/invites"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === '/super/invites'
                ? 'bg-neutral-800 text-white'
                : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
            }`}
          >
            <TicketIcon className="fill-current size-4" />
            Invites
          </Link>
          <Link
            to="/super/audit"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              location.pathname === '/super/audit'
                ? 'bg-neutral-800 text-white'
                : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
            }`}
          >
            <HistoryIcon className="fill-current size-4" />
            Audit
          </Link>
          <Link
            to="/super/metrics-ingestion"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              location.pathname.startsWith('/super/metrics-ingestion')
                ? 'bg-neutral-800 text-white'
                : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
            }`}
          >
            <QueryStatsIcon className="fill-current size-4" />
            Metrics
          </Link>
          <Link
            to="/super/dapp-rankings"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              location.pathname.startsWith('/super/dapp-rankings')
                ? 'bg-neutral-800 text-white'
                : 'text-neutral-400 hover:text-white hover:bg-neutral-800/50'
            }`}
          >
            <LeaderboardIcon className="fill-current size-4" />
            Rankings
          </Link>
        </nav>
      </div>
    </div>
  );
}
